export const userTypes = ["teacher", "student", "guardian"] as const;
export type UserType = typeof userTypes[number];

export function isUserType(value: unknown): value is UserType {
  return typeof value === "string" && userTypes.some((v) => v === value);
}
